// App
import React from 'react';
import { css } from '@/styled-system/css';

// Components
import { SkeletonCard } from 'app/shared/modules/listing-cards/ListingCardV3';

const skeletonListItemCX = css({
  marginBottom: '12px',
  listStyleType: 'none',
});

interface ListSkeletonProps {
  count: number;
}

const ListSkeleton: React.FC<ListSkeletonProps> = ({ count }) => {
  const iterator = [...Array(count).keys()];

  return (
    <ul>
      {iterator.map((_, idx) => (
        <li key={`skeleton-list-${idx}`} className={skeletonListItemCX}>
          <SkeletonCard />
        </li>
      ))}
    </ul>
  );
};

export default ListSkeleton;
